export interface SingleActivityNavParams {
    id?: string;
    isLoadBeforeLaunch?: boolean;
    prevNextBtns?: boolean;
    template?: string;
    title?: string;
    preview?: boolean;
    type?: string;
}
